import {ksuThreeTemplate} from './KsuThreeTemplate'
import {ksuThreeTemplateRTL} from './KsuThreeTemplateRTL'

export default {ksuThreeTemplate,ksuThreeTemplateRTL}